<template>
  <TransitionRoot as="template" :show="openDrawers.length > 0">
    <div class="app-overlay-viewport relative z-40">
      <TransitionChild
        as="template"
        enter="ease-in-out duration-500"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in-out duration-500"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-neutral-950/70 transition-opacity" />
      </TransitionChild>

      <!--
        Click-outside-to-close is bound with `.self` on the two backdrop
        elements rather than with a `.stop` on the panel. The panel wrapper is
        the single child of a Headless UI `as="template"` element, so Headless
        UI owns its listeners and gates them all behind `!event.defaultPrevented`
        — and Headless UI's own controls (a MenuButton opening its menu) call
        `preventDefault()`. A `.stop` there is therefore silently skipped for
        exactly those clicks, and the drawer closes underneath the menu the user
        just opened. `.self` needs no cooperation from anything inside the panel.
      -->
      <div class="fixed inset-0 overflow-hidden">
        <div
          class="absolute inset-0 overflow-hidden"
          @click.self="Drawer.closeAll()"
        >
          <div
            class="fixed inset-y-0 right-0 flex max-w-full sm:pl-10"
            @click.self="Drawer.closeAll()"
          >
            <TransitionChild
              as="template"
              enter="transform transition ease-in-out duration-500 sm:duration-700"
              enter-from="translate-x-full"
              enter-to="translate-x-0"
              leave="transform transition ease-in-out duration-500 sm:duration-700"
              leave-from="translate-x-0"
              leave-to="translate-x-full"
            >
              <div>
                <template v-for="(drawer, index) of openDrawers" :key="index">
                  <DrawerProvider :drawer="drawer">
                    <component :is="drawer.vnode" />
                  </DrawerProvider>
                </template>
              </div>
            </TransitionChild>
          </div>
        </div>
      </div>
    </div>
  </TransitionRoot>
</template>
<script setup lang="ts">
import { TransitionChild, TransitionRoot } from '@headlessui/vue';
import { computed } from 'vue';
import { Drawer } from './drawer';
import DrawerProvider from './DrawerProvider.vue';

const openDrawers = computed(() => {
  const drawers: Drawer[] = Array.from(Drawer.drawers.value.values());
  return drawers;
});
</script>
